import axios from "axios";
import $ from "jquery";
import { Notification } from 'element-ui';

import { RESOURCE_LINKS } from '../../common/constants';
import { FileServices } from '../../services/file.services';
import { detectFileType } from '../../utils/util';

const fileServices = new FileServices();
export default class DocumentLoader {
    /**
     * display default image when the first time DOM is loaded
     * @param el
     */
    inserted(el) {

    }

    /**
     * need reload image when update view model
     * @param el
     * @param binding
     * @param vnode
     * @param oldVnode
     */
    update(el, binding, vnode, oldVnode) {
        DocumentLoader.loadDocument(el, binding, vnode);
    }

    /**
     * bind when created
     * @param el
     * @param binding
     * @param vnode
     */
    bind(el, binding, vnode) {
        DocumentLoader.loadDocument(el, binding, vnode);
    }

    /**
     * support load image
     */

    static loadDocument(el, binding, vnode) {
        if (el.src != null && el.src != "") return;
        console.log("load document");
        if (binding.oldValue === undefined || binding.value !== binding.oldValue) {
            var imageUrl = binding.value;
            if (el.dataset.url == "cloud-storage") {
                DocumentLoader.setDocViewUrl(el, imageUrl, vnode);
            } else {
                axios
                    .get(imageUrl)
                    .then(function (resp) {
                        // need timer to check el has load success
                        let publicLink = resp.data.data.URL;
                        DocumentLoader.setDocViewUrl(el, publicLink, vnode);
                    })
                    .catch(function (ex) {
                        console.error(ex);
                    });
            }
        }
    }

    private static setDocViewUrl(el, publicLink, vnode) {
        const isIframe = el.getAttribute('iframe');
        const index = el.getAttribute('name');
        if (!publicLink || publicLink === "" || publicLink === RESOURCE_LINKS.GENERAL_NOFILEPNG_URL) {
            setTimeout(() => {
                Notification.error({
                    title: vnode.context.$t('ERROR').toString(),
                    message: vnode.context.$t('COULD_NOT_FIND_THE_SELECTED_DOCUMENT').split('|')[0],
                    duration: 8500,
                    customClass: "error"
                })
                vnode.context.$set(vnode.context.isDisplayIframe, index, false)
                // vnode.context.isDisplayIframe[Number(index)] = false;
                vnode.context.$forceUpdate();
            }, 200);
            
            return;
        }
        let viewLink = !isIframe ?
            "https://view.officeapps.live.com/op/embed.aspx?src=" +
            encodeURIComponent(publicLink) : publicLink;
        el.src = viewLink;
        let loadedIntervalChecker = setInterval(function () {
            try {
                let bodyContent = $(el)
                    .contents()
                    .find("body");
                if (bodyContent[0].childNodes.length > 0)  return
                el.src = "";
                el.src = viewLink;
            } catch (err) {
                clearInterval(loadedIntervalChecker);
            }
        }, 5000);
    }

    static async openDocumentOnNewTab({fileName, publicLink}) {
        if (!publicLink) {
            publicLink = (await fileServices.getDocumentPublishLink(fileName))?.URL;
        }

        if (!publicLink) return;

        const checkTypeUrl = publicLink.includes('token') ? publicLink.split('token')[0] : publicLink;

        const isOfficeFile = detectFileType.isExcelFile(fileName) || detectFileType.isWordFile(fileName) || detectFileType.isPowerPointFile(fileName)
            || detectFileType.isExcelFile(checkTypeUrl) || detectFileType.isWordFile(checkTypeUrl) || detectFileType.isPowerPointFile(checkTypeUrl);

        let encodedURI = '';
        if (isOfficeFile) {
            encodedURI = "https://view.officeapps.live.com/op/embed.aspx?src=" + encodeURIComponent(publicLink)
        } else {
            encodedURI = publicLink;
        }

        window.open(encodedURI, '_blank');
    }
}
